import React from 'react';
import{ROLES}from '../../cmps/../services/user.service'
export function ProgressCalculator({customHeight, meta, ejecucion,userRol }) {
    const isEditable = userRol === ROLES.ADMIN

    const calculateProgress = (meta, ejecucion) => {
        if (!meta || meta === 0) return 0;
        return Math.round((ejecucion / meta) * 100); // Redondea el resultado al número entero más cercano
    };

    const progress = calculateProgress(meta, ejecucion);
    

    return (
        
        <div className="task-title picker flex align-center space-between" style={{ width: "10px", height:customHeight}}>
            

                        <blockquote 
                             contentEditable={isEditable}
                            // onBlur={(ev) => handleInputChange(ev, 'medio_verificacion')}
                            suppressContentEditableWarning={true}
                            style={{ marginLeft: "50px", width: "20px", textAlign:'center',cursor: isEditable ? 'pointer' : 'not-allowed' }}
                        >
                            <span style={{textAlign:'center'}}>{progress}%</span>
                        </blockquote>
        </div>

        


    );
}
